import { z } from 'zod';
import { useQuery } from 'react-query';
import { queryKey } from '../units.query-key';
import { getUnitById } from '../infrastructure/get-unit';

export const useGetUnitQuery = (unitId: string) => {
    return useQuery({
        queryKey: [queryKey.units(), unitId],
        queryFn: () => getUnitById(unitId),
        onError(error) {
            if (error instanceof z.ZodError) {
                console.log('error from useGetUnitQuery', error);
            }
        },
    });
};
